import { render, staticRenderFns } from "./PolicyTransactions.vue?vue&type=template&id=7cc7c519&scoped=true&"
import script from "./PolicyTransactions.vue?vue&type=script&lang=ts&"
export * from "./PolicyTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyTransactions.vue?vue&type=style&index=0&id=7cc7c519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc7c519",
  null
  
)

export default component.exports